import { render, staticRenderFns } from "./HeritageMark.vue?vue&type=template&id=2e9bf955&"
import script from "./HeritageMark.vue?vue&type=script&lang=js&"
export * from "./HeritageMark.vue?vue&type=script&lang=js&"
import style0 from "./HeritageMark.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports